import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class ExternalRedirectionService {
  constructor() {}

  redirect(url: string) {
    window.location.href = url;
  }
}
